// Libraries
import i18next from 'i18next';

// load translation namespace(s) for translations
i18next.loadNamespaces(['units']);

/**
 * Description: Map API's UnitType to a short string for distance types
 *      Examples: 'meter' -> 'm', 'yard' -> 'yd', 'mile' -> 'mi', 'kilometer' -> 'km'
 * @param {string} unitType
 * @returns {string}
 */
export const getShortDistanceUnitStr = (unitType) => {
    let unitStr = '';

    switch (unitType) {
        case 'meter':
            unitStr = i18next.t('units:distance.meter');
            break;
        case 'kilometer':
            unitStr = i18next.t('units:distance.kilometer');
            break;
        case 'mile':
            unitStr = i18next.t('units:distance.mile');
            break;
        case 'yard':
            unitStr = i18next.t('units:distance.yard');
            break;
    }

    return unitStr;
};

/**
 * Description: Returns true if the unit key passed in is metric
 * @param {string} unitType
 * @returns {boolean}
 */
export const isUnitMetric = (unitType) => {
    return ['meter', 'kilometer'].includes(unitType);
};
